export class RdStationCallbackController {
    constructor() {
        this.$onInit();
    }
    $onInit() {
        const params = this.processUrl(window.location.href);
        this.code = params.code;
        this.sendPostmessage();
    }
    processUrl(url) {
        const paramStrings = url.split(/#|\?/)[1].split('&');
        return paramStrings.reduce((params, text) => {
            const param = text.split('=')[0];
            const value = text.split('=')[1];
            params[param] = value;
            return params;
        }, {});
    }
    sendPostmessage() {
        setTimeout(() => {
            window.opener.postMessage({
                code: this.code,
            }, '*');
        }, 100);
    }
}
